import script from "./BacklogCards.vue?vue&type=script&setup=true&lang=js"
export * from "./BacklogCards.vue?vue&type=script&setup=true&lang=js"

import "./BacklogCards.vue?vue&type=style&index=0&id=1f510658&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f510658"]])

export default __exports__